import { styled } from '@mui/material/styles';

export const Wrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  padding: '20px 0',
});
